export function percentage(value = 0, decimals = 2) {
  const percentageValue = (value * 100).toFixed(decimals);
  return `${percentageValue}%`;
}

export function percentageChartAxis(value = 0, decimals = 2) {
  return `${+((value * 100) * (10 ** decimals)).toFixed(1) / (10 ** decimals)}%`;
}
